// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_QtY","cls2":"ReferenceEvaluationPage-cls2_fjx ReferenceEvaluationPage-cls1_QtY"};